import { useEffect, useState } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { AsideBox } from "./AsideBox.jsx";
import "./main.css";


const API_KEY = process.env.REACT_APP_API_URL

const ShowAllCategoryApp = () => {
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const [allApps, setAllApps] = useState([]);
  const [tools, setTools] = useState([]);
  const [categoryName, setCategoryName] = useState(
    location.state?.categoryName || ""
  );
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchApps = async () => {
      try {
        const res = await fetch(`${API_KEY}/api/apps`);
        const data = await res.json();
        setAllApps(data.apps || []);
      } catch (err) {
        console.error("Error fetching apps:", err);
      }
    };

    fetchApps();
  }, []);

  useEffect(() => {
    if (allApps.length === 0) return;

    let actualCategory = categoryName;
    if (!actualCategory) {
      const currentApp = allApps.find((app) => app._id === id);
      if (currentApp?.category_id?.name) {
        actualCategory = currentApp.category_id.name;
        setCategoryName(actualCategory);
      }
    }

    if (actualCategory) {
      const filtered = allApps.filter(
        (app) =>
          app.category_id?.name?.toLowerCase() === actualCategory.toLowerCase()
      );
      setTools(filtered);
    } else {
      setTools([]);
    }

    setLoading(false);
  }, [allApps, id, categoryName]);

  return (
    <div className="main-area-box" id="main-area-box1">
      {/* Top Tag Buttons */}
      <div className="tags-area">
        {[
          { icon: "calendar-check-fill", label: "Today" },
          { icon: "newspaper", label: "New" },
          { icon: "bookmark-fill", label: "Most Saved" },
          { icon: "check-circle-fill", label: "Most Used" },
          { icon: "browser-chrome", label: "Browser Ext." },
          { icon: "google-play", label: "Apps" },
          { icon: "discord", label: "Discord" },
          { icon: "twitter", label: "@toolify", social: true },
        ].map((btn, i) => (
          <button
            key={i}
            className={`tag-button ${btn.social ? "tag-social" : ""}`}
          >
            <i className={`bi bi-${btn.icon} pe-2`}></i>
            {btn.label}
          </button>
        ))}
      </div>

      {categoryName && (
        <h1 className="feature-title mt-4 mb-4 animate__animated animate__fadeInDown">
          {categoryName}
        </h1>
      )}

      <div className="content-with-aside">
        <div className="tools-section">
          <div className="row g-3">
            {tools.map((tool, index) => (
              <div
                key={tool._id}
                className="col-lg-4 col-md-6 col-sm-12 animate__animated animate__fadeInUp"
                style={{ animationDelay: `${index * 0.1}s` }}
                onClick={() => navigate(`/api/apps/${tool._id}`)}
              >
                <div className="card h-60 border-0 shadow-sm rounded-4 hover-card">
                  <div className="card-body d-flex flex-column">
                    <div className="d-flex align-items-center mb-3">
                      <div className="logo-container">
                        <img
                          src={`${API_KEY}/temp/${tool?.company_logo}`}
                          alt="Logo"
                          className="logo-img"
                        />
                      </div>
                      <h5 className="ms-3 mb-0 fw-bold text-primary tool-title">
                        {tool.name}
                      </h5>
                    </div>
                    <p className="text-muted tool-description">
                      {tool.description?.length > 100
                        ? tool.description.slice(0, 100) + "..."
                        : tool.description}
                    </p>
                    <div className="hover-indicator">
                      <span className="hover-arrow">→</span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="aside-section">
          {/* <AsideBox /> */}
        </div>
      </div>
    </div>
  );
};

export default ShowAllCategoryApp;
